<template>
  <v-container class="payment-container">
    <v-card class="payment-card mx-auto" elevation="8" max-width="600px">
      <v-card-title class="headline text-center primary white--text py-4">
        <v-icon large color="white" class="mr-2">mdi-wallet-outline</v-icon>
        Compte personnel - Recharge
      </v-card-title>

      <v-card-text class="pt-6">
        <div class="user-info text-center mb-6">
          <v-avatar size="100" class="mb-3">
            <v-img height="100%" src="@/assets/defaultPicturePhoto.png" width="50%" alt="User Avatar"></v-img>
          </v-avatar>
          <h2 class="text-h5 font-weight-medium">{{ user.fullName }}</h2>
          <p class="text-body-1 grey--text">{{ user.email }}</p>
          <v-chip small color="primary" text-color="white" class="mt-1">
            <v-icon left small>mdi-account</v-icon>
            Matricule: {{ user.accountId }}
          </v-chip>
        </div>

        <v-divider class="mb-6"></v-divider>

        <h3 class="text-h6 font-weight-medium mb-4">Saisir le montant de la recharge</h3>

        <v-text-field
            v-model="amount"
            label="Montant"
            outlined
            prefix="FCFA"
            type="number"
            :rules="[rules.required, rules.minAmount]"
            @input="validateAmount"
            color="primary darken-3"
            hint="Montant minimum: 500 FCFA"
        ></v-text-field>

        <div class="amount-summary pa-4 rounded mt-4" :class="{'primary lighten-5': isValidAmount}">
          <div class="d-flex justify-space-between align-center">
            <span class="text-subtitle-1">Montant à charger:</span>
            <span class="text-h6 font-weight-bold">{{ formattedAmount }} XOF</span>
          </div>
          <div class="d-flex justify-space-between align-center mt-2" v-if="amount > 0">
            <span class="text-subtitle-2 grey--text">Frais de transaction:</span>
            <span class="text-subtitle-2">Variable selon le type paiement</span>
          </div>
          <v-divider class="my-3" v-if="amount > 0"></v-divider>
          <div class="d-flex justify-space-between align-center" v-if="amount > 0">
            <span class="text-subtitle-1 font-weight-medium">Total:</span>
            <span class="text-h6 primary--text text--darken-3 font-weight-bold">{{ amount }} FCFA</span>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pb-6 px-6">
        <v-btn
            block
            x-large
            color="primary darken-3"
            dark
            :loading="loading"
            :disabled="!isValidAmount || loading"
            @click="initiatePayment"
            elevation="2"
        >
          <v-icon left>mdi-cash-fast</v-icon>
          Procéder au paiement
        </v-btn>
      </v-card-actions>

      <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          timeout="3000"
          bottom
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn
              text
              v-bind="attrs"
              @click="snackbar.show = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import {invoice} from './paydunyaService'
const { v4: uuidv4 } = require('uuid');

export default {
  data() {
    return {
      loading: false,
      amount: "",
      isValidAmount: false,
      user: {
        fullName: sessionStorage.getItem('name'),
        email: sessionStorage.getItem('email'),
        accountId: sessionStorage.getItem('userId'),
        balance: 0
      },
      rules: {
        required: value => !!value || 'Champ requis',
        minAmount: value => value >= 500 || 'Montant minimum accepté : 500 FCFA'
      },
      snackbar: {
        show: false,
        text: '',
        color: 'info'
      }
    }
  },
  computed: {
    formattedAmount() {
      if (!this.amount) return "0";
      return Number(this.amount).toLocaleString();
    }
  },
  created() {
    sessionStorage.setItem('pendingOrder', null);
  },
  methods: {
    validateAmount() {
      this.isValidAmount = this.amount >= 500;
    },
    calculateFee() {
      if (!this.amount || this.amount < 500) return "0";
      // Example fee calculation (1.5% with a minimum of 100 XOF)
      const fee = Math.max(100, Math.round(this.amount * 0.015));
      return fee.toLocaleString();
    },
    calculateTotal() {
      if (!this.amount || this.amount < 500) return "0";
      const fee = Math.max(100, Math.round(this.amount * 0.015));
      const total = Number(this.amount) + fee;
      return total.toLocaleString();
    },
    async initiatePayment() {
      this.loading = true

      try {
        invoice.description = "Description Optionnelle";
        invoice.totalAmount = this.amount;

        if (invoice.create()
            .then(() => {
              console.log(invoice.status);
              console.log(invoice.token); // Token de facture
              console.log(invoice.responseText);
              console.log(invoice.url); // URL de redirection de paiement de facture PayDunya

              // Redirect to PayDunya payment page
              window.location.href = invoice.url
            })
            .catch(function (e) {
              console.log(e);
            })) {
          console.log('Creation invoice success')
        } else {
          console.log('Creation invoice failed')
        }

        // Store order details for later use
        sessionStorage.setItem('pendingOrder', JSON.stringify({
          total: invoice.totalAmount
        }))

      } catch (error) {
        alert('L\'initialisation du paiement a échoué')
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>